import * as React from 'react';
import { safe, isNullOrUndefined } from "../../utils";
import { IPageProperties } from "../../models";
import { BackToTop, Disclaimer } from "../../assets";

const styles = require('./styles.pcss');
const backToTopstyles = require('./overrides/BackToTopoverride.pcss');

export class PageInvestmentReasons extends React.Component<IPageProperties, {}>{

    constructor(props) {
        super(props);
    }

    render() {
        let { isLoading, shareClass, fund, appParams } = this.props;
        let { clienttype } = appParams
        let investmentReasonsAll = safe(() => fund.statistics.filter(s => s.code === 'investment_reason')[0].values, []) as any as { reason: string; label: string; order: number, client_type: string }[];
        let investmentReasons = safe(() => investmentReasonsAll.filter(s => s.client_type === appParams.clienttype), []) as any as { reason: string; label: string; order: number, client_type: string }[];

        if (!investmentReasons || investmentReasons.length === 0) {
            return null;
        }

        let columnStyles = investmentReasons.length;
        let internalClasses = {
            toggleColumwidth: columnStyles > 2 ? styles.threeColumns : styles.twoColumns,
            toggleVisibility: columnStyles > 2 ? styles.showColumn : styles.hideColumn,
        };

        let heading = "";
        if (clienttype === "adv" || clienttype === "diw") {
            heading = "Reasons to invest in this fund";
        } else {
            heading = "Opportunities and risks";
        }

        investmentReasons.sort((a, b) => a.order - b.order);

        return (
            <div className={ styles.wrapper }>
                <div className={ styles.reasonContainer }>
                    <BackToTop styles={ backToTopstyles } />
                    <h2 className={ styles.title + ' ' + styles.reasons }>{ heading }</h2>
                    {
                        investmentReasons.map((reason, index) => {
                            return (
                                <div key={ index } className={ `${ styles.contentBox } ${ internalClasses.toggleColumwidth } ${ styles[`box${ index + 1 }`] }` }>
                                    <div className={ `${ styles.numberId } ${ index !== 0 ? styles[`box${ index + 1 }`] : "" }` }>{ index + 1 }</div>
                                    <h4>{ reason.label }</h4>
                                    <p>{ reason.reason }</p>
                                </div>
                            );
                        })
                    }
                    { (() => {
                        if (!isNullOrUndefined(shareClass.disclaimers["shareclass_reasonsinvest"]) && !shareClass.disclaimers["shareclass_reasonsinvest"][0].is_deleted) {
                            return (
                                <div className={ styles.disclaimer }>
                                    <Disclaimer appParams={ appParams } disclaimer={ shareClass.disclaimers["shareclass_reasonsinvest"] }></Disclaimer>
                                </div>
                            );
                        }
                    })() }
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/client/components/PageInvestmentReasons/index.tsx